import { Image } from '@utmb/design-system/image/Image';
import SliceExpandableCardsCollectionCardView from '@utmb/types/view/SliceExpandableCardsCollectionCardView';
import { ReactElement } from 'react';
import styles from './expandable-cards-collection.module.scss';

export const ExpandableSlidePhoto = (props: SliceExpandableCardsCollectionCardView): ReactElement | null => {
    const { picture } = props;

    if (!picture) return null;

    return (
        <div className={styles.slider_photo_item}>
            <Image layout="fill" objectFit="cover" image={picture} maxWidth={500} />
        </div>
    );
};
